import { BadgePanel, HonestyPopover, type PanelRow } from './Popover'
import { CHIP_BASE } from './chrome'
import { t } from '@/lib/ui'

// divergence badge (DESIGN-BRIEF §4): violet chip, dashed outline. Marks a
// design that goes BEYOND observed current Kela practice, so a viewer never
// mistakes an ambition for what Kela does today (SIM-015). Deep-links to the
// divergence register (META-004); the register id is passed by later WPs.
// FI default label is "poikkeama"; EN surfaces pass label="divergence".

interface DivergenceBadgeProps {
  /** What exceeds current practice, and how. */
  note?: string
  /** META-004 entry id, e.g. "A1". */
  divergenceId?: string
  /** e.g. "rul-039" — deep-links to /spec/:id */
  specId?: string
  label?: string
}

export function DivergenceBadge({ note, divergenceId, specId, label }: DivergenceBadgeProps) {
  const rows: PanelRow[] = []
  if (divergenceId) rows.push({ label: t('honesty.popover.registerLabel'), value: divergenceId })

  // Accessible name must CONTAIN the visible label text (WCAG 2.5.3 Label in Name).
  const visibleLabel = label ?? t('honesty.divergence.label')

  return (
    <HonestyPopover
      triggerAriaLabel={`${visibleLabel} – ${t('honesty.divergence.name')}`}
      triggerClassName={`${CHIP_BASE} border border-dashed border-divergence text-divergence hover:bg-divergence/10`}
      triggerLabel={visibleLabel}
    >
      <BadgePanel
        name={t('honesty.divergence.name')}
        hint={note ?? t('honesty.divergence.hint')}
        rows={rows}
        specId={specId}
      />
    </HonestyPopover>
  )
}
